<template>
    <p v-if="!(isExceeded.length || isExceeded.lines)"
        :class="`text-[14px] sm:text-[15px] md:text-[16px] 3xl:text-[17px] mt-2 md:mt-3 font-normal multi-lines-text text-[#000000] max-h-[200px] overflow-y-hidden`">
        {{ text }}
    </p>
    <p v-if="isExceeded.length || isExceeded.lines"
        :class="`text-[14px] sm:text-[15px] md:text-[16px] 3xl:text-[17px] mt-2 md:mt-3 font-normal multi-lines-text text-[#000000]  `">
        {{ isSeeMore ?
            text
            :
            croppedText
        }}
        <span class="hover:text-[#385cff] text-[#676767] cursor-pointer " @click="isSeeMore = !isSeeMore">
            {{ isSeeMore ? $t('general.see_less') : $t('general.see_more') }}
        </span>
    </p>
</template>

<script>

export default {
    name: 'TextSeeMore',
    props: {
        text: {
            type: String,
            required: true,
            default: () => ''
        },
        LimitLength: {
            type: Number,
            required: false,
            default: () => 140
        },
        LimitLines: {
            type: Number,
            required: false,
            default: () => 2
        },
    },

    data() {
        return {
            isSeeMore: false,
        };
    },
    computed: {
        isExceeded() {
            this.isSeeMore=false
            return {
                length: this.textValidation()?.isLengthExceed,
                lines: this.textValidation()?.islinesExceed
            }
        },
        croppedText() {
            if (this.isExceeded.length && this.isExceeded.lines) {
                //first reduce lines
                let limitedLinesText= this.getLimitedlinesText(this.text,this.LimitLines)
                //then reduce length
                let limitedLengthText=this.getLimitedLengthText(limitedLinesText,this.LimitLength)

                return limitedLengthText

            } else if (this.isExceeded.length) {
                return this.getLimitedLengthText(this.text,this.LimitLength)
            } else if (this.isExceeded.lines) {
                return this.getLimitedlinesText(this.text,this.LimitLines)
            }
        },
    },
    methods: {
        getLineCount(text) {
            const newlineCount = (text.match(/\n/g) || []).length;
            return newlineCount;
        },
        textValidation() {
            let lenCond=this.text?.length > this.LimitLength
            let lineCond=this.getLineCount(this.text) > this.LimitLines
            
            if (lenCond&&lineCond) {
                return { 
                    isLengthExceed: true,
                    islinesExceed: true,                   
                }
            } else if (lenCond) {
                return { 
                    isLengthExceed: true,
                    islinesExceed: false,                   
                }
            }else if (lineCond) {
                return { 
                    isLengthExceed: false,
                    islinesExceed: true,                   
                }
            }
        },
        getLimitedlinesText(text, limitedLines) {
            //first convert text into array of lines  
            let linesArr = text.split('\n')
            // then take lines that you want ---to not Exceed limted lines 
            let LimitedLinesArr = linesArr.slice(0, limitedLines)
            // then back array to string again
            let LimitedlinesText = LimitedLinesArr.join('\n')

            return LimitedlinesText
        },
        getLimitedLengthText(text,limitedLength){
            let LimitedLengthText = text?.slice(0, limitedLength)
            return LimitedLengthText
        }
    },

};
</script>

<style scoped></style>
